import { useEntitlement } from '@features/entitlements';

interface TelehealthAccess {
  /** Whether the user has telehealth access (entitlement exists). False while loading. */
  hasAccess: boolean;
  /** Whether the entitlement data is still loading */
  isLoading: boolean;
}

export function useTelehealthAccess(): TelehealthAccess {
  const { entitlement, isLoading } = useEntitlement('telehealth');

  // Still loading — default to hidden to prevent flash.
  if (isLoading) {
    return { hasAccess: false, isLoading: true };
  }

  // Entitlement present = access (non-metered, no quota check needed)
  return { hasAccess: !!entitlement, isLoading: false };
}
